module.exports = __webpack_public_path__ + "static/media/item-4.0425c568.png";